<template>
  <UiCard id="tracking" as="section" class="lp-tracking" aria-labelledby="tracking-title">
    <div class="lp-tracking-intro"><span class="lp-icon-tile" aria-hidden="true"><UiIcon name="box" /></span><div><h2 id="tracking-title">{{ title || $t('publicSite.trackShipment') }}</h2><p>{{ $t('publicSite.trackingHelp') }}</p></div></div>
    <form novalidate class="lp-tracking-form" :aria-busy="loading" @submit.prevent="submit">
      <UiFormField id="public-booking" :label="$t('ui.bookingNumber')" :error="error" required v-slot="field">
        <UiInput :id="field.id" v-model="number" :required="field.required" :invalid="field.invalid" :aria-describedby="field.describedby" :disabled="loading" dir="ltr" autocomplete="off" :placeholder="$t('enter_booking_number')" />
      </UiFormField>
      <UiButton type="submit" :loading="loading"><UiIcon name="search" />{{ $t('publicSite.trackShipment') }}</UiButton>
    </form>
  </UiCard>
</template>
<script>
import { UiCard, UiIcon, UiFormField, UiInput, UiButton } from '@/components/ui';
export default {
  name: 'TrackingSearch', components: { UiCard, UiIcon, UiFormField, UiInput, UiButton },
  props: { value: { type: String, default: '' }, title: { type: String, default: '' } },
  data() { return { number: this.value, error: '', loading: false }; },
  watch: { value(next) { this.number = next; this.error = ''; } },
  methods: {
    async submit() {
      if (this.loading) return;
      this.error = '';
      if (!this.number.trim()) { this.error = this.$t('please_enter_booking_number'); this.$nextTick(() => document.getElementById('public-booking')?.focus()); return; }
      this.loading = true;
      try { await this.$router.push({ path: '/book', query: { track: this.number } }); }
      catch { this.error = this.$t('publicSite.navigationError'); }
      finally { this.loading = false; }
    }
  }
};
</script>
